import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCountrywiseRevenue } from "../../services/countryrevenue.services";

export const fetchCountrywiseRevenue = createAsyncThunk(
  "countrywiseRevenue/fetch",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getCountrywiseRevenue(groupBy);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const countrywiseRevenueSlice = createSlice({
  name: "countrywiseRevenue",
  initialState: {
    monthly: [], // Monthly revenue data
    yearly: [], // Yearly revenue data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountrywiseRevenue.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCountrywiseRevenue.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.meta.arg === "month") {
          state.monthly = action.payload.monthly_countrywise_revenue;
        } else if (action.meta.arg === "year") {
          state.yearly = action.payload.yearly_countrywise_revenue;
        }
      })
      .addCase(fetchCountrywiseRevenue.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default countrywiseRevenueSlice.reducer;
